import { APITransport } from '@client/transports/api';

export const PushHistoryService = {
  get(query = {}) {
    return APITransport.post({
      path: '/rest/domain/execute/getpushhistory',
      query
    });
  }
};
